exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove_table_shadow .datatable .table-responsive{box-shadow:none!important}", ""]);

// exports
